import React from 'react'
import { bool, func, array } from 'prop-types'
import styled from 'styled-components'
import { stripUnit } from 'polished'
import { Link } from 'gatsby'

import { CheckoutConsumer } from 'contexts/Checkout'
import { H4, fontWeights, fontSizes } from 'styles/typography'
import { borderColor, black, greyDark } from 'styles/colors'
import Modal, { ModalSection } from 'components/Modal'
import Button from 'components/button/Button'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const DiscountCode = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.medium};
  border: 1px solid ${borderColor};

  ${media.medium`
    padding: ${stripUnit(spacing.medium) * 1.25 + 'px'};
  `};

  & + & {
    border-top: 0;
  }
`

const Code = styled.strong`
  color: ${greyDark};
  display: block;
  margin-bottom: ${stripUnit(spacing.tiny) * 0.5 + 'px'};
`

const Value = styled.span`
  font-size: ${fontSizes.tiny};
  display: block;
`

const Action = styled(Link)`
  color: ${black};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  text-transform: uppercase;
`

const VypePlusDiscountCodesModal = ({ visible, close, vypePlusDiscountCodes }) => (
  <Modal visible={visible} close={close}>
    <CheckoutConsumer>
      {({ checkout, checkoutUrl }) => {
        if (!checkout) return null

        return (
          <>
            <ModalSection>
              <H4>Take advantage of your discount code</H4>
            </ModalSection>
            <ModalSection>
              {vypePlusDiscountCodes
                .filter(c => !c.usedAt)
                .map((discountCode, i) => (
                  <DiscountCode key={i}>
                    <div
                      css={`
                        flex: 1;
                        padding-right: ${spacing.large};
                      `}
                    >
                      <Code>{discountCode.code}</Code>
                      <Value>
                        {discountCode.code.startsWith('BDAY')
                          ? 'Free cartridge'
                          : `${Math.round(parseFloat(discountCode.priceRule.value))}% on your entire order.`}
                      </Value>
                    </div>

                    <Action to={checkoutUrl({ discount: discountCode.code })} as="a" onClick={close}>
                      Use code
                    </Action>
                  </DiscountCode>
                ))}
            </ModalSection>
            <ModalSection>
              <Button to={checkoutUrl()} theme="secondary" as="a" onClick={close}>
                No thanks
              </Button>
            </ModalSection>
          </>
        )
      }}
    </CheckoutConsumer>
  </Modal>
)

VypePlusDiscountCodesModal.propTypes = {
  visible: bool.isRequired,
  close: func.isRequired,
  vypePlusDiscountCodes: array.isRequired
}

export default VypePlusDiscountCodesModal
